import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../constants/constants';
import { RECIPIENT_FILTERS } from './constants';

export const componentKey = "RECIPIENT/RECIPIENT_LIST"

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {

        setLoadingState: (state, action) => {
            state.loadingState = action.payload
        },

        setRecipientList: (state, action) => {
            state.recipientList = action.payload
        },

        setHighlightedRecipient: (state, action) => {
            state.highlightedRecipient = action.payload
        },

        setSelectedRecipients: (state, action) => {
            state.selectedRecipients = action.payload
        },

        setPaginationState: (state, action) => {
            state.paginationState = { ...state.paginationState, ...action.payload }
        },

        toggleSelectedRecipient: (state, action) => {
            const { recipient, selectedRecipients, isChecked } = action.payload;

            if (!isChecked) {
                state.selectedRecipients = selectedRecipients.filter(selectedRow => selectedRow.RecipentDetailId !== recipient?.RecipentDetailId)
            } else {
                state.selectedRecipients = [...selectedRecipients, recipient];
            }
        },

        setDeleteRecipientConfirmationModalOpen: (state, action) => {
            state.deleteRecipientConfirmationModalOpen = action.payload
        },

        setBulkAddressMatchModalOpen: (state, action) => {
            state.bulkAddressMatchModalOpen = action.payload;
        },

        setExportToExcelModal: (state, action) => {
            state.exportToExcelModal = action.payload;
        },

        setBulkInActivateModalOpen: (state, action) => {
            state.bulkInActivateModalOpen = action.payload
        },

        setBulkReActivateModalOpen: (state, action) => {
            state.bulkReActivateModalOpen = action.payload
        },

        setRequestConsentModalOpen: (state, action) => {
            state.requestConsentModalOpen = action.payload;
        },

        setSingleActivateReactivateModal: (state, action) => {
            state.singleActivateReactivateModal = action.payload;
        },
        
        setShouldReloadPaginatedRecipientList: (state, action) => {
            state.shouldReloadPaginatedRecipientList = action.payload;
        },

        setIsUpdateEmailSuccess: (state, action) => {
            state.isUpdateEmailSuccess = action.payload
        },
        setPayerDropdownPagination: (state, action) => {
            state.payerDropdownPagination = { ...state.payerDropdownPagination, ...action.payload }
        },

    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.LOADING, message: "" },
        recipientList: [],
        highlightedRecipient: {},
        selectedRecipients: [],

        paginationState: {
            PageNumber: 1,
            PageSize: 10,
            FilterText: "",
            IsDesc: false,
            IdNumber: "",
            Skip: 0,
            totalRecipients: 10,
            emailid: "",
            TINStatus: "",
            ActiveInactiveStatus: { label: "", value: "" },
            W8W9Status: { label: "", value: "" },
            TINMatch: { label: "", value: "" },
            ...RECIPIENT_FILTERS
        },

        payerDropdownPagination: {
            PageNumber: 1,
            PageSize: 10,
        },

        // Modals
        deleteRecipientConfirmationModalOpen: false,
        bulkAddressMatchModalOpen: false,
        exportToExcelModal: false,
        bulkInActivateModalOpen: false,
        bulkReActivateModalOpen: false,
        requestConsentModalOpen: false,
        singleActivateReactivateModal: false,
        shouldReloadPaginatedRecipientList: false,
        isUpdateEmailSuccess: false,
    }
});

export const { setLoadingState, setRecipientList, setHighlightedRecipient, setSelectedRecipients, setPaginationState, toggleSelectedRecipient, setDeleteRecipientConfirmationModalOpen, setBulkAddressMatchModalOpen, setExportToExcelModal, setBulkInActivateModalOpen, setBulkReActivateModalOpen, setRequestConsentModalOpen, setSingleActivateReactivateModal, setShouldReloadPaginatedRecipientList, setIsUpdateEmailSuccess, setPayerDropdownPagination } = actions;
